import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  Notification_Category,
  Notification_ReadState,
} from '@wavingroup/iot-core/gen/ts/wavin/blaze/v1/notification_pb';
import { setNotificationReadStateForUserBulk } from '~/services/api/fetchers/setNotificationReadStateForUserBulk.api';
import { BlazeDeviceQueryKey } from '~/services/queryKeys';

interface UseSetNotificationReadStateForUserBulkParams {
  readState: Notification_ReadState;
  categoryFilter?: Notification_Category;
  filterDeviceName?: string;
}

export function useSetNotificationReadStateForUserBulk() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      readState,
      categoryFilter,
      filterDeviceName,
    }: UseSetNotificationReadStateForUserBulkParams) =>
      setNotificationReadStateForUserBulk({
        readState,
        categoryFilter,
        filterDeviceName,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [BlazeDeviceQueryKey.LIST_NOTIFICATIONS],
      });
    },
  });
}
